import { useEffect, useState } from "react";

// Custom hook for media query
const useIsMobile = (breakpoint = 820) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const listener = () => setIsMobile(media.matches);
    media.addEventListener("change", listener);
    setIsMobile(media.matches);
    return () => media.removeEventListener("change", listener);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;